import React from "react";
import Navbar from "../Navbar/Navbar";
import { Form, Input, InputNumber, Button, Checkbox } from "antd";
import "./presc.css";
import { PlusOutlined } from "@ant-design/icons";

function AddPrescription() {
  const onFinish = (values) => {
    console.log(values);
  };
  function onChange(checkedValues) {
    console.log("checked = ", checkedValues);
  }

  const options = [
    { label: "Morning", value: "Morning" },
    { label: "Afternoon", value: "Afternoon" },
    { label: "Evening", value: "evening" },
    { label: "Night", value: "night" },
  ];

  return (
    <>
      <Navbar />

      <Form name="nest-messages" onFinish={onFinish} className="mainform">
        <div>
          <div className="flexbox2_input">
            <div>
              <label for="medicine_name">Medicine Name</label>
              <Form.Item
                className="input_med"
                id="medicine_name"
                name={["user", "name"]}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </div>

            <div>
              <label for="medicine_dosage">Dosage</label>
              <Form.Item id="medicine_dosage">
                <InputNumber />
              </Form.Item>
            </div>
          </div>

          <Checkbox.Group
            options={options}
            defaultValue={["Apple"]}
            onChange={onChange}
            className="checkbox_presc"
          />
        </div>
        <div className="width_text">
          <label for="medicine_text">Remarks</label>

          <Form.Item id="medicine_text" name={["user", "introduction"]}>
            <Input.TextArea autoSize={{ minRows: 3, maxRows: 5 }} />
          </Form.Item>
        </div>
      </Form>

      <div className="add_icon_patient">
        <Button>
          <PlusOutlined />
        </Button>
      </div>
    </>
  );
}

export default AddPrescription;
